<div class="portfolio-skeleton-container">
  <div class="row1"></div>

  <div class="section1">
    <div class="row2"></div>
    <div class="section1-squares">
      <div class="square"></div>
      <div class="square"></div>
      <div class="square"></div>
      <div class="square"></div>
    </div>
  </div>

  <div class="section2">
    <div class="section2-1">
      <div class="row2"></div>
      <div class="section2-1-squares">
        <div class="square2"></div>
        <div class="square2"></div>
        <div class="square2"></div>
      </div>
    </div>
    <div class="section2-2">
      <div class="square3"></div>
    </div>
  </div>

  <div class="row2"></div>
  <div class="row3"></div>
</div>
